<div class="notification-wrapper">
    <button type="button" class="notification-trigger" (click)="toggleDropdown()" title=""
        aria-label="Activity Notifications">

        <span class="mail-icon" aria-hidden="true">✉</span>

        <span class="notification-badge" *ngIf="unreadCount > 0">
            {{ unreadCount }}
        </span>

    </button>

    @if (isOpen) {
    <section class="notification-dropdown">
        <header class="notification-header">
            <div>
                <h3>Activity Notifications</h3>
                <p>
                    {{ unreadCount }} unread
                </p>
            </div>

            <button type="button" class="close-button" (click)="isOpen = false" aria-label="Close notifications">
                &times;
            </button>
        </header>

        <div class="notification-list">
            @if (isLoading) {
            <div class="notification-state">
                Loading notifications...
            </div>
            } @else if (loadError && notifications.length === 0) {
            <div class="notification-state error-state">
                Could not load notifications.
                <button type="button" class="retry-button" (click)="loadNotifications()">
                    Try again
                </button>
            </div>
            } @else if (notifications.length === 0) {
            <div class="notification-state">
                <span class="empty-icon">♧</span>
                <strong>You're all caught up!</strong>
                <span>No notifications yet.</span>
            </div>
            } @else {
            @for (
            item of latestNotifications;
            track item.notification_id
            ) {
            <div class="notification-item" [class.unread]="!item.is_read" (click)="markAsRead(item)">
                <span class="notification-dot"></span>

                <span class="notification-content">
                    <span class="notification-title">{{ item.title }}</span>

                    <span class="notification-message">{{ item.message }}</span>

                    <span class="notification-time">
                        {{ item.created_at | date:'dd MMM yyyy, hh:mm a' }}
                    </span>
                </span>

                @if (!item.is_read) {
                <span class="unread-label">New</span>
                }

                <button type="button" class="dismiss-button" aria-label="Dismiss notification"
                    title="Dismiss notification" (click)="dismissNotification($event, item)">
                    &times;
                </button>
            </div>
            }
            }
        </div>

        <footer class="notification-footer">
            <span>Latest notifications</span>

            <button type="button" (click)="loadNotifications()" [disabled]="isLoading">
                Refresh
            </button>
        </footer>
    </section>
    }
</div>
